module.exports = __webpack_public_path__ + "04_very_short_grey.61874210.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_very_short_grey.png
// module id = OWMR
// module chunks = 0